import React from 'react';

import { PageId } from 'utils/ubi/pageId';

import InternalLink, { LinkProps } from './InternalLink';

const homeLink = (market: string) => `/${market}/`;

const HomeLink = ({ ...props }: LinkProps) => <InternalLink toPage={PageId.Home} hrefFun={homeLink} {...props} />;

export default HomeLink;
